// src/js/imageComparison.js
export function imageComparisonInit() {
  document
    .querySelectorAll(".image-comparison-component")
    .forEach(function (root) {
      var tabs = root.querySelectorAll(".image-comparison-tab");
      var panels = root.querySelectorAll(".image-comparison-panel");
      tabs.forEach(function (tab, idx) {
        tab.addEventListener("click", function () {
          tabs.forEach(function (t, i) {
            t.classList.toggle("active", i === idx);
            panels[i].classList.toggle("hidden", i !== idx);
          });
        });
      });
    });
}
